import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './redux/signInPopupActions';
import {openRegistrationPopup} from '../RegistrationPopup/redux/registrationPopupActions';
import styles from '../../styles/AuthPopup.scss';
import SignInPopupForm from './elements/SignInPopupForm';
import {default as PasswordResetForm} from './elements/SignInPopupPasswordResetForm';
import SignInPopupSocBtns from './elements/SignInPopupSocBtns';

export class SignInPopup extends Component {
  switchToRegistration = () => {
    this.props.actions.closeSignInPopup();
    this.props.actions.openRegistrationPopup();
  };

  render() {
    const {closeSignInPopup} = this.props.actions;
    if (!this.props.isOpen) {
      return null;
    }
    const form = this.props.isResettingPassword
    ? <PasswordResetForm />
    : <SignInPopupForm />;
    return (
      <div>
        <div
        onClick={closeSignInPopup}
        className={styles.backDrop} />

        <div className={styles.popupWindow}>
          <div
            onClick={closeSignInPopup}
            className={styles.closeBtn} />
          <div className={styles.header}>
            Вход
          </div>
          {form}
          {/* <div className={styles.divider} /> */}
          {/* <p
          className={styles.socSignInPrompt}>
            Вход через соц. сеть
          </p>
          <SignInPopupSocBtns
            {...this.props.actions} /> */}
          <div className={styles.divider} />
          <button
            onClick={this.switchToRegistration}
            className="link">Регистрация</button>
        </div>
      </div>
    );
  }
}



SignInPopup.propTypes = {
  actions: PropTypes.object.isRequired,
  isOpen: PropTypes.bool,
  isResettingPassword: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    ...state.signInPopupReducer
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({...actions, openRegistrationPopup}, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignInPopup);



/** WEBPACK FOOTER **
 ** ./src/components/SignInPopup/SignInPopup.jsx
 **/